// extracted by mini-css-extract-plugin
export default {"ToggleContainer":"estilo_ToggleContainer__t8BGY","Indicador":"estilo_Indicador__VJAKM","Descricao":"estilo_Descricao__IxO+J"};